module.exports = __webpack_public_path__ + "img/466.b4fd1dc9.jpg";